import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import { LicenseInfo } from "@mui/x-data-grid-premium";

LicenseInfo.setLicenseKey(
  "75f32c59d370efb2d34bb59f6766a34bTz0xMTY1NDEsRT0xNzg2NDA2Mzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y"
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
